"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionResponseModelCurrency = void 0;
exports.SubscriptionResponseModelCurrency = {
    Usd: "usd",
    Eur: "eur",
};
